var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Form',{attrs:{"fnoname":'200.00',"fnoperiod":'quarter',"fnotitle":'Декларация по индивидуальному подоходному налогу и социальному налогу'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }